import { render } from "./article.svg?vue&type=template&id=c921e58a?inline"
const script = {}
script.render = render

export default script